export const BRAZIL_AIRPORT_VENUES = [
  "AJU", // Aracaju
  "SBHT",
  "BEL", // Belém
  "BFH",
  "BGX",
  "BSB", // Brasília
  "BVB",
  "CGH", // São Paulo/Congonhas
  "CGR",
  "COR",
  "CKS",
  "CMG",
  "CPV",
  "SBCT", // Curitiba
  "CZS",
  "GRU", // São Paulo/Guarulhos
  "GYN", // Goiânia
  "IGU", // Foz do Iguaçu
  "IMP",
  "JDO",
  "JOI",
  "JPA",
  "LDB",
  "MAB",
  "MAO", // Manaus
  "MCP", // Macapá
  "MCZ", // Maceió
  "MGC",
  "MOC",
  "NAT", // Natal
  "NVT",
  "PET",
  "PLU",
  "PMG",
  "PMW",
  "PNZ",
  "PVH",
  "RBR", // Rio Branco
  "REC", // Recife
  "SDU", // Rio de Janeiro/Santos Dumont
  "SLZ", // São Luís
  "STM",
  "TBT",
  "TFF",
  "THE", // Teresina
  "UBA",
  "UDI", // Uberlândia
  "URG",
];
